module.exports = __webpack_public_path__ + "static/3_3_spam-or-ham_SE-5afd8d0f868bce637f2239754b3cc68b.svg";